import { memo, useEffect } from 'react'

import { useAuth } from '@repo/common/queries/auth'

import { LoginSignup } from '@/components/LoginSignup'
import type { BasePanelProps } from '@/flows/flow_helpers'

export const PanelSignup = memo<
  Pick<BasePanelProps, 'onCompleted'> & {
    starting_mode?: ReactProps<typeof LoginSignup>['starting_mode']
  }
>(function PanelSignup({ onCompleted, starting_mode = 'signup' }) {
  const { data } = useAuth()

  useEffect(() => {
    if (data?.is_authenticated) {
      onCompleted()
    }
  }, [data?.is_authenticated, onCompleted])

  return <LoginSignup starting_mode={starting_mode} without_header />
})

export const PanelLogin = (args: ReactProps<typeof PanelSignup>) => (
  <PanelSignup {...args} starting_mode="login" />
)

export const useSkipLogin = () => {
  const { data } = useAuth()
  return Boolean(data?.is_authenticated)
}
